module.exports = __webpack_public_path__ + "static/media/bulb.27b341bb.svg";